module.exports = __webpack_public_path__ + "img/1505259086.8ea79da9.jpg";